import { convert } from 'jcampconverter';
import { getJcampKind } from '../Kinds.js';
/**
 * Create a spectrum from a JCAMP file
 * @param jcampText - String containing the JCAMP data
 * @returns Parsed spectrum data with kind, meta, and info
 */
export default function parseJcamp(jcampText) {
    const parsed = convert(jcampText, {
        keepRecordsRegExp: /.*/,
    }).flatten[0];
    const kind = getJcampKind(parsed);
    const data = parsed.spectra[0].data;
    const { meta, info } = parsed;
    // Convert the data if needed
    if (kind?.importation?.converter) {
        data.y = data.y.map(kind.importation.converter);
    }
    return { data, kind, meta, info };
}
//# sourceMappingURL=parseJcamp.js.map